export enum WebAssetsUrl {
    STREAMLINE = 'https://webassets.revel-health.com'
}
